export default theme => ({

  root: {
    position: 'fixed',
    right: theme.spacing.unit * 6,
    bottom: theme.spacing.unit * 4
  },

  tooltip: {
    'white-space': 'nowrap'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/CollapseAll.js